export enum BotActionEnum {
  GET_IT_NOW,
  SIGN_IN_TO_INSTALL,
  INSTALL,
  REMOVE,
  VIEW_BOT_NAME,
}
